import React,{ Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Field, reduxForm, change} from "redux-form";
import {  Row, Col, UncontrolledTooltip, Card, CardBody, CardHeader, Form, FormGroup, CardFooter, Button, Label } from "reactstrap";
import { getSettings, updateSettings } from "../../actions/actionSettings";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { NotificationManager } from "react-notifications";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import {number, positive_float, renderCheckbox, renderField, renderTextArea, required} from "../../utils/formValidations";
import TooltipComponent from "./TooltipComponent";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Settings",path:"/settings",isActive: true}
];

function titleCase(string)
{
    if (string === "web_filter"){
        return "Web Filter"
    }
    else {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

}

class Settings extends Component{
    constructor(props) {
        super(props);        
        this.state = {
            pages: 1,
            settingId: null,
        };

        this.initializeForm = this.initializeForm.bind(this);
        this.submitSettings = this.submitSettings.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.updateSettings = this.updateSettings.bind(this);

    }

    componentDidMount(){
        this.updateSettings();
    }

    updateSettings() {
        this.props.getSettings()
            .then(() => {
                this.initializeForm();
            });
    }

    initializeForm(){
        const {settings} = this.props;
        if(settings){
            settings.map((setting) => {
                let value = setting.value;
                if (setting.value_type === 'bool') {
                    value = setting.value === 'true';
                }
                this.props.dispatch(change('settingsForm', setting.setting_id, value));
            });
        }
    }

    submitSettings(formValues) {
        let initialValues = {};
        const {settings} = this.props;
        // create array of setting id: setting value to make comparing with form values easier
        for (let set in settings){
            if (settings.hasOwnProperty(set))
                initialValues[settings[set].setting_id] = settings[set].value
        }
        //redux doesnt send empty strings...check for non existant form value to allow empty strings
        for (let setting in initialValues){
            if (initialValues.hasOwnProperty(setting)) {
                if (!formValues.hasOwnProperty(setting)) {
                    if (initialValues[setting] !== "") {
                        let settingsObj = {
                            "setting_id": setting,
                            "value": ''
                        };
                        this.props.updateSettings(settingsObj)
                            .then(() => this.handleUpdateSuccess())
                            .catch(() => this.handleUpdateError())
                    }
                }
            }
        }
        for (let setting in formValues){
            if (formValues.hasOwnProperty(setting)) {
                if (formValues[setting] !== initialValues[setting]) {
                    //adding check for boolean values being different than initial value...had caused all booleans to be sent
                    if (typeof formValues[setting] === "boolean"){
                        if (formValues[setting].toString() !== initialValues[setting]) {
                            let settingsObj = {
                                "setting_id": setting,
                                "value": formValues[setting]
                            };
                            this.props.updateSettings(settingsObj)
                                .then(() => this.handleUpdateSuccess())
                                .catch(() => this.handleUpdateError())
                        }
                    } else {
                        let settingsObj = {
                            "setting_id": setting,
                            "value": formValues[setting]
                        };
                        this.props.updateSettings(settingsObj)
                            .then(() => this.handleUpdateSuccess())
                            .catch(() => this.handleUpdateError())
                    }
                }
            }
        }

    }

    handleUpdateSuccess(){
        const {errorMessage} = this.props;
        if(errorMessage){
            NotificationManager.error(errorMessage,"Update Settings", 3000);
        }
        else {
            NotificationManager.success("Setting Updated", "Setting Updated Successfully");
            this.props.getSettings()
                .then(() => {
                    this.initializeForm();
                });
        }
    }

    handleUpdateError(){
        const {updateSettingsError} = this.props;
        if(updateSettingsError){
            NotificationManager.error(updateSettingsError,"Update Settings", 3000);
        }
    }

    render(){
        if (this.props.getSettingsLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const {handleSubmit, settings, pristine, submitting} = this.props;
        let categories = {};
        //separate settings by category
        JSON.parse(JSON.stringify(settings)).map((setting) => {
            categories[setting.category] = {...categories[setting.category], [setting.name]: setting};
        });

        let settingFields = [];
        for (let category in categories) {
            if (categories.hasOwnProperty(category))
            {
                let fields = [];
                for (let setting in categories[category]) {
                    if (categories[category].hasOwnProperty(setting)) {
                        let field = categories[category][setting];
                        // ensures String and string match
                        let type = field.value_type.toLowerCase();
                        fields.push( <FormGroup key={field.setting_id}>
                                        { type !== 'bool' ?
                                            <Row>
                                                <Col>
                                            <span>
                                                <Label htmlFor={field.setting_id}>
                                                    <TooltipComponent
                                                        description={field.description}
                                                        name={field.title}
                                                    />
                                                </Label>

                                            </span>
                                                </Col>
                                            </Row> : ''}
                                        <Row>
                                            <Col>
                                                { type === 'bool' ?
                                                    <div style={{display: 'flex'}}>
                                                        <Field
                                                            name={field.setting_id}
                                                            id={field.setting_id}
                                                            type = "checkbox"
                                                            checked = {field.value === 'true'}
                                                            component={renderCheckbox}
                                                            placeholder={field.value}
                                                        />
                                                        <Label htmlFor={field.setting_id}>
                                                            <TooltipComponent
                                                                description={field.description}
                                                                name={field.title}
                                                            />
                                                        </Label>
                                                        <TooltipComponent
                                                            description={field.description}
                                                        />
                                                    </div>
                                                    :''
                                                }
                                                { type === 'string' ?
                                                    <Field
                                                        type="text"
                                                        name={field.setting_id}
                                                        id={field.setting_id}
                                                        component={renderField}
                                                        placeholder={field.value}
                                                    /> :''
                                                }
                                                { type === 'multiline_string' ?
                                                    <Field
                                                        type="textarea"
                                                        name={field.setting_id}
                                                        id={field.setting_id}
                                                        component={renderTextArea}
                                                        placeholder={field.value}
                                                    /> :''
                                                }
                                                { type === 'int' ?
                                                    <Field
                                                        name={field.setting_id}
                                                        id={field.setting_id}
                                                        type = "number"
                                                        component={renderField}
                                                        validate={[number]}
                                                        placeholder={field.value}
                                                    /> :''
                                                }
                                                { type === 'float' ?
                                                    <Field
                                                        name={field.setting_id}
                                                        id={field.setting_id}
                                                        type = "textarea"
                                                        component={renderField}
                                                        validate={[ positive_float]}
                                                        placeholder={field.value}
                                                    /> :''
                                                }
                                            </Col>
                                        </Row>
                                    </FormGroup>);
                    }
                }
                // Finally wrap all fields in category with border and title
                settingFields.push(<fieldset key={category}><legend>{titleCase(category)}</legend>{fields}</fieldset>);
            }
        }

        return (
            <div className="settings">
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Col sm={{ size: 8, offset: 2 }}>
                        <Card>
                            <CardHeader>
                                <strong>Settings</strong>
                            </CardHeader>
                            <Form onSubmit={handleSubmit(this.submitSettings)} >
                                <CardBody>
                                    {settingFields && settingFields}
                                </CardBody>
                                <CardFooter>
                                    <FormGroup className="form-actions">
                                        <Button disabled={submitting} type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o" /> Submit</Button>
                                    </FormGroup>
                                </CardFooter>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
        );}

}

Settings.propTypes = {
    getSettings: Proptypes.func.isRequired,
    settings: Proptypes.array,
    updateSettings: Proptypes.func.isRequired,
    history: Proptypes.object.isRequired,
    getSettingsLoading: Proptypes.bool,
};

let SettingsForms =  connect(state => ({
    settings: state.settings.settings || [],
    getSettingsLoading: state.settings.getSettingsLoading || false,
    errorMessage: state.settings.errorMessage || null
}),
dispatch => ({
    getSettings: () => dispatch(getSettings()),
    updateSettings: (data) => dispatch(updateSettings(data))
}))(Settings);


export default reduxForm({
    form: "settingsForm",
})(SettingsForms);


// WEBPACK FOOTER //
// ./src/views/Settings/Settings.js